module.exports = __webpack_public_path__ + "img/logo-play-doh.dfd2f3f9.png";